// src/layout/AppLayout/AppVersion.js
import React from 'react';
import { Box, Typography } from '@mui/material';

// Component for app version footer
const AppVersion = () => (
  <Box sx={{ mt: 'auto', p: 2, textAlign: 'center' }}>
    <Typography variant="caption" color="text.secondary">
      ReadableEnglish v1.0.0
    </Typography>
  </Box>
);

export default AppVersion;